// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"da6de809","244":"239521cd","453":"86d73de1","522":"d2473d08"}[chunkId] + ".chunk.js";
};